export default __webpack_public_path__ + "static/media/visa.ea1f09af.svg";